import { render } from "./SettingsTable.vue?vue&type=template&id=6f222184"
import script from "./SettingsTable.vue?vue&type=script&lang=js"
export * from "./SettingsTable.vue?vue&type=script&lang=js"

import "./SettingsTable.vue?vue&type=style&index=0&id=6f222184&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__